<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <responsiveButton :setText="true"
                                  setColor="orange"
                                  setDefaultIcon="mdi-refresh"
                                  setSmallIcon="mdi-refresh"
                                  :setClick="initialize"
                >
                    Refresh Data
                </responsiveButton>
                <v-divider class="mx-6"></v-divider>
            <v-data-table
                    :headers="headers"
                    :items="templateGroupTypes"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                    :options.sync="pagination"
                    :server-items-length="totalItems"
            >
                <template v-slot:item.documentGroups="{item}">
                    <v-chip color="green" class="white-span" text-color="white">
                        {{ item.documentGroups ? Object.values(item.documentGroups).length : '0' }}
                    </v-chip>
                </template>

                <template v-slot:item.reportGroups="{item}" v-if="templateType == 'client'">
                    <v-chip color="green" class="white-span" text-color="white">
                        {{ item.reportGroups ? Object.values(item.reportGroups).length : '0' }}
                    </v-chip>
                </template>
                <template v-slot:item.systemCreatedDateTime="{item}">
                    {{item.systemCreatedDateTime | formatDate}}
                </template>
                <!--actions-->
                <template v-slot:item.edit="{item}">
                    <v-icon
                            class="mr-2"
                            @click="editTemplateGroupType(item)"
                    >
                        {{ GROUP_TYPE_ACTIONS.EDIT.icon}}
                    </v-icon>
                </template>
                <template v-slot:item.clone="{item}">
                    <v-icon
                            class="mr-2"
                            @click="cloneTemplateGroupType(item)"
                    >
                        {{ GROUP_TYPE_ACTIONS.CLONE.icon}}
                    </v-icon>
                </template>
                <template v-slot:item.remove="{item}">
                    <v-icon
                            class="mx-auto"
                            @click="confirmDelete(item)"
                    >
                        {{ GROUP_TYPE_ACTIONS.DELETE.icon}}
                    </v-icon>
                </template>
            </v-data-table>
        </v-col>
        </v-row>
        <dialog-alert
                :text="confirmAlertText"
                :alert-type="confirmAlertType"
                :open="openConfirmation"
                @alert-closed="dialogClosed($event)"
        ></dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    const GroupTypeForm = ()=> import( "@/components/orgApps/GroupType/GroupTypeForm");
    import {USER_TYPE} from '../../../shared/enums/UserType';
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    import {GROUP_TYPE_ACTIONS} from "../../../shared/enums/GroupTypes";
    const DialogAlert = () => import("@/components/common/DialogAlert");
    import { ALERT_TYPES, CONFIRM_DELETE } from "@/shared/enums/AlertTexts";

    export default {
        name: "groupTypeTable",
        props:['templateType'],
        components:{ GroupTypeForm, responsiveButton, DialogAlert },
        data(){
            return {
                templateGroupTypes: [],
                loading: true,
                types:{
                    employee: USER_TYPE.EMPLOYEE,
                    client: USER_TYPE.CLIENT
                },
                confirmAlertType: ALERT_TYPES.CONFIRM,
                confirmAlertText: CONFIRM_DELETE,
                openConfirmation: false,
                groupTypeToDelete: null,
                pagination: {},
                pageKeyCache: new Map(),
                totalItems: 0
            };
        },
        computed:{
           getTypesStoreMethod(){
                   return this.templateType.charAt(0).toUpperCase() + this.templateType.slice(1)+'Types';
           },
           GROUP_TYPE_ACTIONS(){
               return GROUP_TYPE_ACTIONS;
           },
           headers(){
               let headers = [
                   {
                       text: 'Name',
                       align: 'left',
                       sortable: true,
                       value: 'name'
                   },
                   {
                       text: 'Document Categories',
                       align: 'center',
                       sortable: true,
                       value: 'documentGroups',
                       divider: false
                   }];

               if(this.templateType == 'client')
                   headers.push({
                       text: 'Report Categories',
                       align: 'center',
                       sortable: true,
                       value: 'reportGroups',
                       divider: false
                   });

               headers.push(
                   {
                       text: 'Created Date',
                       align: 'center',
                       sortable: true,
                       divider: true,
                       value: 'systemCreatedDateTime'
                   },
                   {
                       text: 'Edit',
                       align: 'center',
                       width: '2%',
                       value: 'edit',
                       sortable: false
                   },
                   {
                       text: 'Clone',
                       align: 'center',
                       width: '2%',
                       value: 'clone',
                       sortable: false
                   },
                   {
                       text: 'Remove',
                       align: 'center',
                       width: '2%',
                       value: 'remove',
                       sortable: false
                   });

               return headers;
           }
        },
        watch: {
            pagination: {
                async handler() {
                    await this.getTemplateGroupTypes();
                },
                deep: true
            },
        },
        methods:{
            initialize() {
                this.getTemplateGroupTypes();
            },
            async getTemplateGroupTypes() {
                this.loading = true;
                let params = this.getPaginationValues();

                if(!params.limit)
                    return;

                try{
                    let method = 'get'+this.getTypesStoreMethod;
                    await this.$store.dispatch(method, params);
                    this.templateGroupTypes = this.$store.getters[method];
                }
                catch (e) {
                    //set alert
                    this.loading = false;
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }

                this.setPaginationValues(this.templateGroupTypes);

                this.loading = false;
            },
            setPaginationValues(list){
                let key = this.$store.getters['get'+this.getTypesStoreMethod+'Key'];
                const {page} = this.pagination;

                if(key != null && Object.keys(key).length > 0){
                    this.pageKeyCache.set(page, key);
                    this.totalItems = list.length +1;
                }
                else{
                    this.totalItems = list.length;
                }
            },
            getPaginationValues(){
                //all values of pagination that can be used for backend
                const { page, itemsPerPage } = this.pagination;
                let params = {
                    limit: itemsPerPage
                }

                if(this.pageKeyCache.has(page) && page != 1){
                    params.lastEvaluatedKey = this.pageKeyCache.get(page);
                }
                else {
                    //we have not been there yet, so it needs to be to cases 1: this is brand new search page 0
                    // or it is the next page that we has not seem
                    if(page != 1) {
                        params.lastEvaluatedKey = this.pageKeyCache.get(page-1);
                    }
                }
                return params;
            },
            async cloneTemplateGroupType(groupType){
                this.$store.commit('setGroupType',{...groupType});
                this.$router.push({name:'groupTypeAction', params: {id: groupType.id,action: GROUP_TYPE_ACTIONS.CLONE.text,type:this.templateType}});
            },
            async editTemplateGroupType(groupType){
                this.$store.commit('setGroupType',groupType);
                this.$router.push({name:'groupTypeAction', params: {id: groupType.id,action: GROUP_TYPE_ACTIONS.EDIT.text,type:this.templateType}});
            },
            async deleteTemplateGroupType(templateGroupType){
                const index = this.templateGroupTypes.indexOf(templateGroupType);

                await this.$store.dispatch('deleteGroupType',{id:templateGroupType.id});
                let response = this.$store.getters.getGroupType;

                this.templateGroupTypes.splice(index, 1);
                this.groupTypeToDelete = null;
            },
            confirmDelete(item) {
                this.openConfirmation = true;
                this.groupTypeToDelete = item;
            },
            dialogClosed(answer) {
                this.openConfirmation = false;
                if (answer) {
                    this.deleteTemplateGroupType(this.groupTypeToDelete);
                }
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>